import { Visibility, VisibilityOff } from "@mui/icons-material"; // Import the Close icon
import SaveIcon from "@mui/icons-material/Save";
import {
  Dialog,
  DialogActions,
  Grid,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import appcolors from "../../constants/Colors";
import globalStyle from "../../globalStyle";
import GlobalButton from "../CustomButton";
import Label from "../Label";
import TextInput from "../TextInputs";
import DialogBody from "./Body";
import DialogHeader from "./Header";
import DialogActionButtons from "./Footer";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogActions-root": {
    padding: "25px 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "25px  8px",
    },
  },
}));
let paramsData = {};

const ProfileSaveDialog = forwardRef(({ handleSaveProfile }, ref) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(["common"]);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
      setPassword("");
      setPasswordError(false);
      setShowPassword(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setShowPassword(false);
    setPassword("");
    setPasswordError(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >

      <DialogHeader
        title={t("saveProfile")}
        secondaryHeading={t("profileSaveDescription")}
        onClose={handleClose}
        icon={<SaveIcon />}
      />

      <DialogBody>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label labelText={t("password")} required />
            <TextInput
              required={true}
              styleProps={globalStyle.textField}
              type={showPassword ? "text" : "password"}
              inputError={passwordError}
              helperText={passwordError && t("validation.passwordRequired")}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError(false);
              }}
              InputEndIcon={
                showPassword ? (
                  <Visibility
                    onClick={() => setShowPassword(false)}
                    style={{ cursor: "pointer", color: appcolors.black }}
                  />
                ) : (
                  <VisibilityOff
                    onClick={() => setShowPassword(true)}
                    style={{ cursor: "pointer", color: appcolors.black }}
                  />
                )
              }
            />
          </Grid>
        </Grid>
        <Typography
          mt={2}
          variant="body2"
          color={"primary.main"}
        >
          {t("changedDetails")}?
        </Typography>
      </DialogBody>

      <DialogActionButtons
        onConfirm={() => {
          if (password) {
            handleSaveProfile(password);
          } else {
            setPasswordError(true);
          }
        }}
        onCancel={handleClose}
        confirmText={"save"}
        cancelText={"cancel"}
        showCancelButton={true}
      />
    </BootstrapDialog>
  );
});

export default ProfileSaveDialog;
